import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL ?? '').trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim();

export const isSupabaseConfigured = supabaseUrl.length > 0 && supabaseAnonKey.length > 0;

export const supabaseConfigError = isSupabaseConfigured
	? null
	: 'Missing Supabase dashboard config. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY, or provide SUPABASE_URL and SUPABASE_ANON_KEY in the repo root .env file.';

export const supabase = createClient(
	isSupabaseConfigured ? supabaseUrl : 'http://127.0.0.1:54321',
	isSupabaseConfigured ? supabaseAnonKey : 'local-dev-placeholder-anon-key',
);
